var abilitiesEn = {
    "1": "Stench",
    "2": "Drizzle",
    "3": "Speed Boost",
    "4": "Battle Armor",
    "5": "Sturdy",
    "6": "Damp",
    "7": "Limber",
    "8": "Sand Veil",
    "9": "Static",
    "10": "Volt Absorb",
    "11": "Water Absorb",
    "12": "Oblivious",
    "13": "Cloud Nine",
    "14": "Compound Eyes",
    "15": "Insomnia",
    "16": "Color Change",
    "17": "Immunity",
    "18": "Flash Fire",
    "19": "Shield Dust",
    "20": "Own Tempo",
    "21": "Suction Cups",
    "22": "Intimidate",
    "23": "Shadow Tag",
    "24": "Rough Skin",
    "25": "Wonder Guard",
    "26": "Levitate",
    "27": "Effect Spore",
    "28": "Synchronize",
    "29": "Clear Body",
    "30": "Natural Cure",
    "31": "Lightning Rod",
    "32": "Serene Grace",
    "33": "Swift Swim",
    "34": "Chlorophyll",
    "35": "Illuminate",
    "36": "Trace",
    "37": "Huge Power",
    "38": "Poison Point",
    "39": "Inner Focus",
    "40": "Magma Armor",
    "41": "Water Veil",
    "42": "Magnet Pull",
    "43": "Soundproof",
    "44": "Rain Dish",
    "45": "Sand Stream",
    "46": "Pressure",
    "47": "Thick Fat",
    "48": "Early Bird",
    "49": "Flame Body",
    "50": "Run Away",
    "51": "Keen Eye",
    "52": "Hyper Cutter",
    "53": "Pickup",
    "54": "Truant",
    "55": "Hustle",
    "56": "Cute Charm",
    "57": "Plus",
    "58": "Minus",
    "59": "Forecast",
    "60": "Sticky Hold",
    "61": "Shed Skin",
    "62": "Guts",
    "63": "Marvel Scale",
    "64": "Liquid Ooze",
    "65": "Overgrow",
    "66": "Blaze",
    "67": "Torrent",
    "68": "Swarm",
    "69": "Rock Head",
    "70": "Drought",
    "71": "Arena Trap",
    "72": "Vital Spirit",
    "73": "White Smoke",
    "74": "Pure Power",
    "75": "Shell Armor",
    "76": "Air Lock",
    "77": "Tangled Feet",
    "78": "Motor Drive",
    "79": "Rivalry",
    "80": "Steadfast",
    "81": "Snow Cloak",
    "82": "Gluttony",
    "83": "Anger Point",
    "84": "Unburden",
    "85": "Heatproof",
    "86": "Simple",
    "87": "Dry Skin",
    "88": "Download",
    "89": "Iron Fist",
    "90": "Poison Heal",
    "91": "Adaptability",
    "92": "Skill Link",
    "93": "Hydration",
    "94": "Solar Power",
    "95": "Quick Feet",
    "96": "Normalize",
    "97": "Sniper",
    "98": "Magic Guard",
    "99": "No Guard",
    "100": "Stall",
    "101": "Technician",
    "102": "Leaf Guard",
    "103": "Klutz",
    "104": "Mold Breaker",
    "105": "Super Luck",
    "106": "Aftermath",
    "107": "Anticipation",
    "108": "Forewarn",
    "109": "Unaware",
    "110": "Tinted Lens",
    "111": "Filter",
    "112": "Slow Start",
    "113": "Scrappy",
    "114": "Storm Drain",
    "115": "Ice Body",
    "116": "Solid Rock",
    "117": "Snow Warning",
    "118": "Honey Gather",
    "119": "Frisk",
    "120": "Reckless",
    "121": "Multitype",
    "122": "Flower Gift",
    "123": "Bad Dreams",
    "124": "Pickpocket",
    "125": "Sheer Force",
    "126": "Contrary",
    "127": "Unnerve",
    "128": "Defiant",
    "129": "Defeatist",
    "130": "Cursed Body",
    "131": "Healer",
    "132": "Friend Guard",
    "133": "Weak Armor",
    "134": "Heavy Metal",
    "135": "Light Metal",
    "136": "Multiscale",
    "137": "Toxic Boost",
    "138": "Flare Boost",
    "139": "Harvest",
    "140": "Telepathy",
    "141": "Moody",
    "142": "Overcoat",
    "143": "Poison Touch",
    "144": "Regenerator",
    "145": "Big Pecks",
    "146": "Sand Rush",
    "147": "Wonder Skin",
    "148": "Analytic",
    "149": "Illusion",
    "150": "Imposter",
    "151": "Infiltrator",
    "152": "Mummy",
    "153": "Moxie",
    "154": "Justified",
    "155": "Rattled",
    "156": "Magic Bounce",
    "157": "Sap Sipper",
    "158": "Prankster",
    "159": "Sand Force",
    "160": "Iron Barbs",
    "161": "Zen Mode",
    "162": "Victory Star",
    "163": "Turboblaze",
    "164": "Teravolt",
    "165": "Aroma Veil",
    "166": "Flower Veil",
    "167": "Cheek Pouch",
    "168": "Protean",
    "169": "Fur Coat",
    "170": "Magician",
    "171": "Bulletproof",
    "172": "Competitive",
    "173": "Strong Jaw",
    "174": "Refrigerate",
    "175": "Sweet Veil",
    "176": "Stance Change",
    "177": "Gale Wings",
    "178": "Mega Launcher",
    "179": "Grass Pelt",
    "180": "Symbiosis",
    "181": "Tough Claws",
    "182": "Pixilate",
    "183": "Gooey",
    "184": "Aerilate",
    "185": "Parental Bond",
    "186": "Dark Aura",
    "187": "Fairy Aura",
    "188": "Aura Break",
    "189": "Primordial Sea",
    "190": "Desolate Land",
    "191": "Delta Stream",
    "192": "Stamina",
    "193": "Wimp Out",
    "194": "Emergency Exit",
    "195": "Water Compaction",
    "196": "Merciless",
    "197": "Shields Down",
    "198": "Stakeout",
    "199": "Water Bubble",
    "200": "Steelworker",
    "201": "Berserk",
    "202": "Slush Rush",
    "203": "Long Reach",
    "204": "Liquid Voice",
    "205": "Triage",
    "206": "Galvanize",
    "207": "Surge Surfer",
    "208": "Schooling",
    "209": "Disguise",
    "210": "Battle Bond",
    "211": "Power Construct",
    "212": "Corrosion",
    "213": "Comatose",
    "214": "Queenly Majesty",
    "215": "Innards Out",
    "216": "Dancer",
    "217": "Battery",
    "218": "Fluffy",
    "219": "Dazzling",
    "220": "Soul-Heart",
    "221": "Tangling Hair",
    "222": "Receiver",
    "223": "Power of Alchemy",
    "224": "Beast Boost",
    "225": "RKS System",
    "226": "Electric Surge",
    "227": "Psychic Surge",
    "228": "Misty Surge",
    "229": "Grassy Surge",
    "230": "Full Metal Body",
    "231": "Shadow Shield",
    "232": "Prism Armor",
    "233": "Neuroforce",
    "234": "Intrepid Sword",
    "235": "Dauntless Shield",
    "236": "Libero",
    "237": "Ball Fetch",
    "238": "Cotton Down",
    "239": "Propeller Tail",
    "240": "Mirror Armor",
    "241": "Gulp Missile",
    "242": "Stalwart",
    "243": "Steam Engine",
    "244": "Punk Rock",
    "245": "Sand Spit",
    "246": "Ice Scales",
    "247": "Ripen",
    "248": "Ice Face",
    "249": "Power Spot",
    "250": "Mimicry",
    "251": "Screen Cleaner",
    "252": "Steely Spirit",
    "253": "Perish Body",
    "254": "Wandering Spirit",
    "255": "Gorilla Tactics",
    "256": "Neutralizing Gas",
    "257": "Pastel Veil",
    "258": "Hunger Switch",
    "259": "Quick Draw",
    "260": "Unseen Fist",
    "261": "Curious Medicine",
    "262": "Transistor",
    "263": "Dragon's Maw",
    "264": "Chilling Neigh",
    "265": "Grim Neigh",
    "266": "As One",
    "267": "As One",
    "268": "Lingering Aroma",
    "269": "Seed Sower",
    "270": "Thermal Exchange",
    "271": "Anger Shell",
    "272": "Purifying Salt",
    "273": "Well-Baked Body",
    "274": "Wind Rider",
    "275": "Guard Dog",
    "276": "Rocky Payload",
    "277": "Wind Power",
    "278": "Zero to Hero",
    "279": "Commander",
    "280": "Electromorphosis",
    "281": "Protosynthesis",
    "282": "Quark Drive",
    "283": "Good as Gold",
    "284": "Vessel of Ruin",
    "285": "Sword of Ruin",
    "286": "Tablets of Ruin",
    "287": "Beads of Ruin",
    "288": "Orichalcum Pulse",
    "289": "Hadron Engine",
    "290": "Opportunist",
    "291": "Cud Chew",
    "292": "Sharpness",
    "293": "Supreme Overlord",
    "294": "Costar",
    "295": "Toxic Debris",
    "296": "Armor Tail",
    "297": "Earth Eater",
    "298": "Mycelium Might",
    "299": "Hospitality",
    "300": "Mind's Eye",
    "301": "Embody Aspect",
    "302": "Embody Aspect",
    "303": "Embody Aspect",
    "304": "Embody Aspect",
    "305": "Toxic Chain",
    "306": "Supersweet Syrup",
    "307": "Tera Shift",
    "308": "Tera Shell",
    "309": "Teraform Zero"
}
export default abilitiesEn;